import React from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid/v4';

import arrows from 'assets/img/arrows.svg';
import styles from './LeftRightButton.scss';

const LeftRightButton = ({ onClick }) => [
  <img
    className={styles.LeftRightButtonArrows}
    src={arrows}
    key={uuidv4()}
    alt="arrows"
  />,
  <button
    className={styles.LeftRightButton}
    onClick={onClick}
    key={uuidv4()}
  >
    <span>Click here to press both buttons</span>
  </button>
];

LeftRightButton.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default LeftRightButton;



// WEBPACK FOOTER //
// ./src/components/buttons/HardwareButton/LeftRightButton/LeftRightButton.js